var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("InventoryTab", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tab === "inventory",
            expression: "tab === 'inventory'"
          }
        ],
        on: {
          switch: function($event) {
            _vm.tab = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.canBins
        ? _c("BinTab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "bin",
                expression: "tab === 'bin'"
              }
            ],
            on: {
              switch: function($event) {
                _vm.tab = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canStockTaking
        ? _c("StockTakingTab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "stockTaking",
                expression: "tab === 'stockTaking'"
              }
            ],
            on: {
              switch: function($event) {
                _vm.tab = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }